import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { Observable, of } from 'rxjs';
import { StiiizyStrainCardData } from '../../../../../../../models/print-cards/stiiizy-strain-card-data';
import { iiif$ } from '../../../../../../../utils/observable.extensions';
import { map, shareReplay } from 'rxjs/operators';

@Injectable()
export class StiiizyStrainIndexCardStackContentViewModel extends PrintCardContentViewModel {
  protected readonly MAX_STRAINS_THAT_CAN_APPEAR_ON_CARD = 5;

  public readonly cardData$: Observable<StiiizyStrainCardData>;

  public readonly isStiiizyBrandedCard$ = this.cardData$.pipe(
    map(cardData => cardData?.isStiiizyBrandedCard()),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  public readonly stiiizyCardBackgroundColor$ = iiif$(this.isStiiizyBrandedCard$, of('black'), this.cardColor$).pipe(
    shareReplay({ bufferSize: 1, refCount: true })
  );

  public readonly visibleVariantStrains$ = this.cardData$.mapTo$(cardData => {
    return cardData?.rowVariants?.take(this.MAX_STRAINS_THAT_CAN_APPEAR_ON_CARD);
  });

  public readonly nMoreStrains$ = this.cardData$.pipe(
    map(cardData => {
      const nMoreStrains = cardData?.rowVariants?.length - this.MAX_STRAINS_THAT_CAN_APPEAR_ON_CARD;
      return nMoreStrains > 0 ? nMoreStrains : 0;
    })
  );
}
